/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1TradingScheduleVersionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_TRADING_SCHEDULE_VERSION_EVENT_ENTITY_NAME = 'ixf.hours.v1.TradingScheduleVersionEvent';
export const ixfHoursV1TradingScheduleVersionEventEntity = new schema.Entity<IxfHoursV1TradingScheduleVersionEvent>(IXF_HOURS_V1_TRADING_SCHEDULE_VERSION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfHoursV1TradingScheduleVersionEvent) => `${entity.metadata?.eventId}` });

